
import { app } from '@microsoft/teams-js';
import { getPlaywrightTestSetup } from '../../features/utils/PlaywrightTestSetup';

export interface AuthEnvironment {
    isInTeams: boolean;
    isInBrowser: boolean;
    isSharePoint: boolean;
}

let cachedEnvironment: AuthEnvironment | null = null;

export const resolveAuthEnvironment = async (): Promise<AuthEnvironment> => {
    if (cachedEnvironment) return cachedEnvironment;

    const playwrightTestEnvironment = getPlaywrightTestSetup()?.environment;
    if (playwrightTestEnvironment) {
        cachedEnvironment = playwrightTestEnvironment;
        return playwrightTestEnvironment;
    }

    let isInTeams = false;
    try {
        await app.initialize();
        isInTeams = app.isInitialized();
    } catch {
        // Not running inside a Teams host — treat as browser.
    }

    // SharePoint embeds the app in an iframe and may also initialize TeamsJS.
    // If the referrer matches the configured SharePoint domain, treat it as
    // a browser context so NAA and Teams-specific flows are not applied.
    const isSharePoint = document.referrer.includes(process.env.REACT_APP_SHAREPOINT_DOMAIN as string);
    if (isSharePoint) {
        isInTeams = false;
    }

    cachedEnvironment = { isInTeams, isInBrowser: !isInTeams, isSharePoint };
    return cachedEnvironment;
};

export const getCachedAuthEnvironment = (): AuthEnvironment | null => cachedEnvironment;

